module.exports = __webpack_public_path__ + "static/media/2-02.4511e41e.png";